import React from "react";
import { Row, Col, Stack, Image } from "react-bootstrap";
import "../App.css";

function Footer() {
  return (
    <footer>
      <div className="container">
        <Row className="text-center text-md-start" style={{ margin: "auto" }}>
          <Col xs={12} md={3} className="mb-4">
            <Stack className="align-items-center align-items-md-start">
              <Image
                className="remc-img-footer"
                src="/logo-transparent-cut.png"
                alt="REMC"
              />
            </Stack>
          </Col>

          {/* <Col xs={12} md={3} className="mb-4 text-center text-md-start">
            <h5>REMC</h5>
            <p style={{ fontSize: "0.9rem" }}>
              <a href="/about">About Us</a>
            </p>
            <p style={{ fontSize: "0.9rem" }}>
              <a href="/event">Events</a>
            </p>
            <p style={{ fontSize: "0.9rem" }}>
              <a href="/our-members">Our Members</a>
            </p>
          </Col> */}

          {/* <Col xs={12} md={3} className="mb-4 text-center text-md-start">
            <h5>Policy</h5>
            <p style={{ fontSize: "0.9rem" }}>
              <a href="/privacy-policy">Privacy Policy</a>
            </p>
            <p style={{ fontSize: "0.9rem" }}>
              <a href="/terms-of-service">Terms of Service</a>
            </p>
          </Col> */}

          <Col xs={12} md={3} className="mb-4 text-center text-md-start">
            <h5>Contact</h5>
            <p style={{ fontSize: "0.9rem" }}>Phone: +1 (289) 628-7888</p>
          </Col>
        </Row>

        <hr />

        <div></div>

        <div className="copyright-container text-center">
          <p>&copy; {new Date().getFullYear()} REMC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
